<script setup lang="ts">
  import { Button } from '@ui/components/button';
  import { cn } from '@ui/utils/utils';

  import type { InputGroupButtonProps } from '.';
  import { inputGroupButtonVariants } from '.';

  const props = withDefaults(defineProps<InputGroupButtonProps>(), {
    size: 'xs',
    variant: 'ghost',
  });
</script>

<template>
  <Button
    :data-size="props.size"
    :variant="props.variant"
    :class="cn(inputGroupButtonVariants({ size: props.size }), props.class)"
  >
    <slot />
  </Button>
</template>
